import * as Backbone from "backbone";
import _ from "lodash";
import {invokeLastFunc} from 'util/FuncUtil';

export const ManageView = Backbone.View.extend({
	initialize: function (options) {
		this.selpan = options.selpan;
		this.delayed = invokeLastFunc(this, ['render']);
		this.listenTo(this.collection, 'update reset', this.delayed.render);
		this.delayed.render();
	},
	remove: function () {
		_.each(this.childViews, function (v) {
			v.remove();
		});
		Backbone.View.prototype.remove.apply(this, arguments);
	},
	render: function () {
		let that = this;
		_.each(this.childViews, function (v) {
			v.remove();
		});
		this.childViews = this.collection.map(function (m) {
			return new that.ChildView({model: m, selpan: that.selpan});
		});
		this.$el.html(_.map(this.childViews, function (v) {
			return v.el;
		}));
	},
});
